<template>
  <SlideIn :open="isOpen" heading="Account" @close="handleDismiss">
    <template #content>
      <component :is="selectedForm" @success="handleFormSuccess" />
    </template>
  </SlideIn>
</template>

<script>
import SlideIn from "@/components/SlideIn.vue";
import { mapGetters, mapActions } from "vuex";
import addDays from "date-fns/addDays";
import isAfter from "date-fns/isAfter";
import isSameDay from "date-fns/isSameDay";
import parseISO from "date-fns/parseISO";
import formatISO from "date-fns/formatISO";

import RegisterAndLoginPanel from "@/components/account/RegisterAndLoginPanel.vue";
import PhoneNumberForm from "@/components/account/PhoneNumberForm.vue";
import DateOfBirthForm from "@/components/account/DateOfBirthForm.vue";

export default {
  name: "DataCollection",
  components: {
    SlideIn,
  },
  data() {
    return {
      open: false,
      formConfig: {
        RegisterAndLoginPanel,
        PhoneNumberForm,
        DateOfBirthForm,
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "hasPhoneNumber", "hasBirthday"]),
    ...mapGetters("app", ["dataCollectionDismissed"]),
    selectedForm() {
      if (!this.isLoggedIn) return RegisterAndLoginPanel;
      if (!this.hasPhoneNumber) return PhoneNumberForm;
      if (!this.hasBirthday) return DateOfBirthForm;
      return null;
    },
    isOpen: {
      get() {
        if (this.selectedForm === null) {
          return false;
        }
        return !(this.dataCollectionDismissed || !this.open);
      },
      set(value) {
        this.open = value;
      },
    },
  },
  watch: {
    selectedForm(newForm, oldForm) {
      if (newForm !== oldForm) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkIfShouldOpen();
    }, 5 * 1000);
  },
  methods: {
    ...mapActions("app", ["setUserPreferences"]),
    handleDismiss() {
      this.setUserPreferences({
        key: "dataCollectionDismissed",
        value: true,
      });
    },
    handleFormSuccess(redirect) {
      const currentDate = formatISO(new Date());
      localStorage.setItem("shopifyDataCollectionDate", currentDate);
      this.isOpen = false;

      if (redirect) {
        redirect();
      }
    },
    checkIfShouldOpen() {
      const storedDate = localStorage.getItem("shopifyDataCollectionDate");

      if (!storedDate) {
        this.isOpen = true;
        return;
      }

      const parsedStoredDate = parseISO(storedDate);
      const currentDate = new Date();
      const oneDayAfterStoredDate = addDays(parsedStoredDate, 1);
      const isOneDayAfter =
        isAfter(currentDate, oneDayAfterStoredDate) ||
        isSameDay(currentDate, oneDayAfterStoredDate);

      this.isOpen = isOneDayAfter;
    },
  },
};
</script>
